import axios, { AxiosRequestConfig } from 'axios';
import { getSessionCredentials } from '../../../globalFunctions';

let sounds = [];
  const fetchParabens = async () => {
    const user =  getSessionCredentials()  

    if (user) {
      const requestConfig: AxiosRequestConfig = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`,
          Accept: 'application/json',
        },
      };
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/erros`, requestConfig);
        sounds = data.map((som) => som.som)
        console.log(sounds)
      } catch (error) {
        console.error('Erro ao buscar parabéns:', error);
      }
    }
  };

  fetchParabens()

// array que vai embaralhar os sons
let shuffledSounds: string[] = [];
let currentIndex = 0;

// função para embaralhar
function shuffle(array: string[]) {
  return array
    .map(value => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

export function RisadaAleatoria() {
  if (shuffledSounds.length === 0 || currentIndex >= shuffledSounds.length) {
    // embaralha novamente se acabou o ciclo
    shuffledSounds = shuffle(sounds);
    currentIndex = 0;
  }

  const audio = new Audio(shuffledSounds[currentIndex]);
  audio.play();

  currentIndex++;
}